function isBetween(timestamp: number, range: { start: number, end: number }): boolean {
  const { start, end } = range;
  return timestamp > start && timestamp < end;
}

export default isBetween;